import * as yup from 'yup'

// helper for yup transform function
function emptyStringToNull(value, originalValue) {
  if (typeof originalValue === 'string' && originalValue === '') {
    return null
  }
  return value
}

// eslint-disable-next-line func-names
yup.addMethod(yup.number, 'numberNullable', function () {
  return this.transform(emptyStringToNull).nullable()
})
